import { render, staticRenderFns } from "./AvailabilityFeature.vue?vue&type=template&id=4fdcfb7f&"
import script from "./AvailabilityFeature.vue?vue&type=script&lang=ts&"
export * from "./AvailabilityFeature.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AvailabilityFeature.vue"
export default component.exports